import Vue from 'vue';
import {
  toast,
  modal,
  Button
} from '@mx/vix';

[Button].map((c) => Vue.use(c));

Vue.prototype.$toast = toast;
Vue.prototype.$modal = modal;

export * from './env';
export * from './horn';
export * from './api';
export * from './bridge';
export * from './logan';
export * from './monitor';
